import React from 'react';
import styled from 'styled-components';
import { Tooltip, TrevorIcon } from '@trevor/ui-components';
import { DrilldownOnboarding } from './DrilldownOnboarding';

const DrilldownButtonContainer = styled.div`
  position: relative;
`;

export const _DrilldownButton: React.FC<any> = ({
  className,
  rowIndex,
  expanded,
  handleClick,
}) => (
  <DrilldownButtonContainer className={className}>
    <TrevorIcon
      name="chevron-right"
      style={{
        transform: expanded ? 'rotate(90deg)' : '',
        cursor: 'pointer',
      }}
      data-tooltip-id={`${rowIndex}_drilldown`}
      onClick={handleClick}
    />
    {rowIndex === 1 && <DrilldownOnboarding />}

    <Tooltip id={`${rowIndex}_drilldown`}>Drilldown</Tooltip>
  </DrilldownButtonContainer>
);

export const DrilldownButton = styled(_DrilldownButton)`
  display: flex;
  justify-content: center;
`;
